import AccordionItemHandler from '@/components/forms/new/AccordionItemHandler';
import DefaultPartnerPlan from '../formFields/DefaultPartnerPlan';
import BillTo from '../formFields/BillTo';
import BillingDay from '../formFields/BillingDay';
import DefaultCompanyBillingDay from '../formFields/DefaultCompanyBillingDay';
import BillingToggles from '../formFields/BillingToggles';
import Surcharge from '../formFields/Surcharge';
import AllowPlansPerNumber from '../formFields/AllowPlansPerNumber';
import TrackingName2 from '../formFields/TrackingName2';
import TrackingOption2 from '../formFields/TrackingOption2';
import MinUserCount from '../formFields/MinUserCount';
import MinResourceAccountCount from '../formFields/MinResourceAccountCount';

const PartnerBillingSettings = ({
    errors,
    touched,
    darkMode,
    defaultPlansData,
}) => {
    const formFields = [
        <DefaultPartnerPlan
            key="defaultPlan"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            defaultPlansData={defaultPlansData}
        />,
        <BillTo
            key="billTo"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        // <BillingDay
        //     key="billingDay"
        //     errors={errors}
        //     touched={touched}
        //     darkMode={darkMode}
        // />,
        // <DefaultCompanyBillingDay
        //     key="defaultCompanyBillingDay"
        //     errors={errors}
        //     touched={touched}
        //     darkMode={darkMode}
        // />,
        <BillingToggles key="toggles" darkMode={darkMode} />,
        <Surcharge
            key="surcharge"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        // <AllowPlansPerNumber
        //     key="allowPlansPerNumber"
        //     errors={errors}
        //     touched={touched}
        //     darkMode={darkMode}
        // />,
        <TrackingName2
            key="trackingName2"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <TrackingOption2
            key="trackingOption2"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <MinUserCount
            key="minBillableUsers"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <MinResourceAccountCount
            key="minBillableResourceAccounts"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
    ];

    return (
        <AccordionItemHandler
            index={0}
            key="partnerBillingInvoiceSettings"
            label="Billing Settings"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {formFields.filter(Boolean)}
        </AccordionItemHandler>
    );
};

export default PartnerBillingSettings;
